<template>
  <div class="evaluate-and-connect">
    <div class="evaluate" @click="handleEvaluate">
      <svgicon class="icon-evaluate" name="icon-evaluate"></svgicon>
      <span>满意度评价</span>
    </div>
    <div class="line"></div>
    <div class="connect" @click="handleConnect">
      <svgicon class="icon-evaluate" name="connect"></svgicon>
      <span>咨询客服</span>
    </div>
  </div>
</template>

<script>
//重连-评价model

import evaluateAndConnect from "src/mixins/evaluateAndConnect";
export default {
  name: "reconnect-model",
  mixins: [evaluateAndConnect]
};
</script>

<style scoped lang="less">
.evaluate-and-connect {
  display: flex;
  align-items: center;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 55;
  border-top: 1px solid #eaeaea;
  .evaluate,
  .connect {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    cursor: pointer;

    span {
      display: inline-block;
      width: 100%;
    }
  }
}

.mobile {
  .evaluate-and-connect {
    height: 100px;

    .evaluate,
    .connect {
      width: 50%;
      span {
        font-size: 12px;
        color: var(--evaluate-finished-text);
        &:active {
          color: var(--evaluate-finished-text-click);
        }
      }
      .icon-evaluate {
        width: 45px;
        height: 45px;
        fill: var(--header-bg) !important;
      }
      /*i {*/
      /*  margin-bottom: 5px;*/

      /*  &.icon-evaluate {*/
      /*    width: 42px;*/
      /*    height: 37px;*/
      /*  }*/

      /*  &.icon-connect {*/
      /*    width: 45px;*/
      /*    height: 45px;*/
      /*  }*/
      /*}*/
    }

    .line {
      width: 1px;
      height: 70px;
      background-color: #eaeaea;
    }
  }
}
</style>
